import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { DocumentationComponent } from '@bn/app-shield';
import { PlanType } from '@bn/app-shield/enums';
import { AbstractLazyDirective } from '@bn/shared/entities/abstracts/abstract-lazy.directive';
import { LinkListItem } from '@bn/web-ui/link-list/models';
import { ShieldApiStore } from '../../stores';

@Component({
  templateUrl: './app-shield-waf.page.html',
  styleUrls: ['./app-shield-waf.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, DocumentationComponent],
})
export class AppShieldWafPage extends AbstractLazyDirective implements OnDestroy {
  readonly #shieldStore = inject(ShieldApiStore);
  readonly selectedShield = this.#shieldStore.selectedEntity();

  public currentTab!: string;

  public titleFirst = 'Documentation';
  public linksFirst?: LinkListItem[] = [
    { text: 'Overview', url: 'https://docs.bunny.net/shield' },
    { text: 'Troubleshooting', url: 'https://docs.bunny.net/shield/troubleshooting' },
    { text: 'API Specifications', url: 'https://api.bunny.net/shield/docs/index.html' },
  ];

  constructor() {
    super();
    // set local variable for parent page to be able to use onRouterOutletLoaded
    this.route.firstChild?.data.subscribe(({ activeTab }) => {
      this.currentTab = activeTab;
    });

    this.subscribeToStoreSignals();
  }

  public ngOnDestroy(): void {
    this.contentService.setBadge(null);
  }

  private subscribeToStoreSignals(): void {
    toObservable(this.selectedShield)
      .pipe(filter((shield) => !!shield))
      .pipe(takeUntilDestroyed())
      .subscribe((shield) => {
        const plan = shield?.planType || 0;

        if (plan > PlanType.Basic) {
          const planName = PlanType[plan];

          this.contentService.setBadge({
            contextType: 'premium',
            text: planName,
            tooltip: `You have Bunny Shield ${planName} enabled`,
          });
        } else {
          this.contentService.setBadge(null);
        }
      });
  }
}
